import { type PermissionEnum } from "@dashboard/graphql";

/**
 * The rewards module is a JBM-custom backend addition, so `MANAGE_REWARDS` is not
 * present in the checked-in `schema-main.graphql` snapshot and therefore not in the
 * generated `PermissionEnum`. The backend exposes it as `RewardsPermissions.MANAGE_REWARDS`
 * (`rewards.manage_rewards`) and returns it in `user.userPermissions[].code`, so the
 * literal is compared as-is at runtime. Once the schema snapshot is refreshed this can
 * be replaced with `PermissionEnum.MANAGE_REWARDS`.
 */
export const MANAGE_REWARDS = "MANAGE_REWARDS" as PermissionEnum;
